export default __webpack_public_path__ + "assets/dashboard-experts-d599e11f57d471fae7c6bab26816413a.svg";